var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 35,
    viewBox: "0 0 50 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8901 5.45903C48.6034 4.40389 48.044 3.44195 47.2678 2.669C46.4916 1.89605 45.5256 1.33906 44.466 1.0535C40.5866 0 24.9737 0 24.9737 0C24.9737 0 9.35993 0.0318888 5.48061 1.08539C4.42095 1.37097 3.45492 1.92799 2.6787 2.70097C1.90249 3.47395 1.34318 4.43593 1.05647 5.49111C-0.116931 12.3546 -0.572116 22.813 1.08869 29.4019C1.37543 30.4571 1.93475 31.419 2.71096 32.192C3.48718 32.9649 4.4532 33.5219 5.51283 33.8075C9.39215 34.861 25.0055 34.861 25.0055 34.861C25.0055 34.861 40.6187 34.861 44.4978 33.8075C45.5575 33.5219 46.5235 32.965 47.2998 32.192C48.076 31.4191 48.6354 30.4571 48.9221 29.4019C50.1598 22.5287 50.5411 12.0768 48.8901 5.45903Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0059 24.9005L32.958 17.4304L20.0059 9.96021V24.9005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.246b8ff570ed0ff84454d6709a587785.svg";
export { ForwardRef as ReactComponent };